import i18n from "src/i18n/config";
import { z } from "zod";

const invalidCharsRegex = /[+@!]/;

export const schema = z.object({
    email: z.string(),
    phoneCode: z.string().nullable().optional(),
    newsletterChecked: z.boolean(),
    twoFactorEnabled: z.boolean(),
    profileCompleted: z.boolean(),
    name: z
        .string(i18n.t("common:validation.custom.nameRequired"))
        .min(1, i18n.t("common:validation.custom.nameRequired"))
        .max(32, i18n.t("common:validation.custom.nameMax"))
        .refine((val) => !invalidCharsRegex.test(val), {
            message: i18n.t("common:validation.custom.nameSpecialChars"),
        }),
    address: z
        .string()
        .max(64, i18n.t("common:validation.custom.addressMax"))
        .nullable()
        .optional()
        .refine((val) => !val || val === "" || !invalidCharsRegex.test(val), {
            message: i18n.t("common:validation.noSpecialCharacters"),
        }),
    zipCode: z
        .string()
        .optional()
        .refine((val) => !val || val === "" || /^[a-zA-Z0-9\s-]+$/.test(val), {
            message: i18n.t("common:validation.custom.zipCodeAllowedChars"),
        }),
    phoneNumber: z
        .string(i18n.t("common:validation.phoneNumber"))
        .min(7, i18n.t("common:validation.custom.phoneMinMax"))
        .max(32, i18n.t("common:validation.custom.phoneMinMax"))
        .nullable()
        .optional()
        .refine((val) => !val || /^\+?[0-9\s-]+$/.test(val), {
            message: i18n.t("common:validation.phoneNumber"),
        }),
    companyName: z
        .string()
        .max(64, i18n.t("common:validation.custom.companyNameMax"))
        .nullable()
        .optional()
        .refine((val) => !val || !invalidCharsRegex.test(val), {
            message: i18n.t("common:validation.noSpecialCharacters"),
        }),
    fieldOfApplication: z
        .string()
        .max(64, i18n.t("common:validation.custom.fieldOfApplicationMax"))
        .nullable()
        .optional()
        .refine((val) => !val || !invalidCharsRegex.test(val), {
            message: i18n.t("common:validation.noSpecialCharacters"),
        }),
    city: z
        .string()
        .max(32, i18n.t("common:validation.custom.cityMax"))
        .optional()
        .refine((val) => !val || val === "" || !invalidCharsRegex.test(val), {
            message: i18n.t("common:validation.noSpecialCharacters"),
        }),
    country: z.string().min(1, i18n.t("common:validation.custom.countryRequired")),
    typeOfUsage: z.enum(["b", "nb"], {
        message: i18n.t("common:validation.custom.typeOfUsageRequired"),
    }),
});
